import s from './SubmittedRequests.module.css';
import { Text } from '../../Language/Language';
import { Flex } from '@repo/ui/Flex';
import { Box } from '@repo/ui/Box';
import { Separator } from '@repo/ui/Separator';
import { useWorkflow } from '../../../workflow/hooks';
import { RequestCard } from '../../RequestCard/RequestCard';

export const SubmittedRequests = () => {
  const { submittedRequests, retailer } = useWorkflow();

  if (!submittedRequests || submittedRequests.length === 0) {
    return null;
  }

  return (
    <>
      <Box padding={['py-32', 'md:py-64']}>
        <Separator size="lg" />
      </Box>
      <Flex
        padding={['px-24', 'md:px-0']}
        gap={['g-24', 'md:g-32']}
        direction="column"
      >
        <Flex gap="g-4" direction="column">
          <h1 className={s.title}>
            <Text langKey="Global.itemSelection.RequestsHeader" />
          </h1>
          <p className={s.description}>
            <Text langKey="Global.itemSelection.RequestsDescription" />
          </p>
        </Flex>
        <div className={s.grid}>
          {submittedRequests.map((request) => (
            <RequestCard key={request.id} {...request} retailer={retailer} />
          ))}
        </div>
      </Flex>
    </>
  );
};
